import { FC } from 'react'
import { ContactForm } from '../../sections/ContactForm/ContactForm'

export const Contact: FC = () => (
  <section>
    <div>
      <h1>Contact</h1>
      <p>Get in touch with us via our contact form</p>
      <ContactForm />
    </div>
  </section>
)
